import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LOCALE } from './config';
import text from './text';

Vue.use(VueI18n);

export default new VueI18n({
  locale: LOCALE,
  fallbackLocale: LOCALE,
  messages: text,
  silentTranslationWarn: true,
});
